import React from 'react';
import { Container, Grid, Card, CardContent, Typography, Button, useTheme, useMediaQuery, Box, Avatar, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import BarChartIcon from '@mui/icons-material/BarChart';

// Import text content
import { documentsTexts } from '../texts/documents';

// Icon mapping
const iconMap = {
  'BusinessIcon': BusinessIcon,
  'DirectionsBoatIcon': DirectionsBoatIcon,
  'AssuredWorkloadIcon': AssuredWorkloadIcon
};

const DocumentsCollections = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { collections: collectionsTexts } = documentsTexts;
  
  return (
    <Container maxWidth="1500px" width="100%" sx={{ minHeight: 'calc(100vh - 116px)', bgcolor: 'background.paper', py: 4 }}>
      <Typography
        variant="h2"
        component="h1"
        sx={{ mb: 6, textAlign: 'center', color: 'text.secondary' }}
      >
        {collectionsTexts.title}
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {collectionsTexts.collections.map((col, idx) => {
          const IconComponent = iconMap[col.icon];
          return (
            <Grid item xs={12} md={4} key={col.name}>
              <Card 
                variant="outlined" 
                sx={{ 
                  height: 350, 
                  borderRadius: 5,
                  maxWidth: isLargeScreen ? 400 : '100%',
                  bgcolor: 'background.default',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0px 6px 12px rgba(0,0,0,0.15)'
                  }
                }}
              >
                <CardContent sx={{ 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <Avatar 
                      sx={{ 
                        bgcolor: idx % 2 === 0 ? theme.palette.primary.main : theme.palette.secondary.main, 
                        mr: 2,
                        width: 40,
                        height: 40
                      }}
                    >
                      <IconComponent />
                    </Avatar>
                    <Typography variant="h6" component="h2" gutterBottom>
                      {col.name}
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                    {col.description}
                  </Typography>
                  <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                    <Button
                      component={RouterLink}
                      to="/dashboard"
                      variant="outlined"
                      color={idx % 2 === 0 ? "primary" : "secondary"}
                      size="small"
                      sx={{ borderRadius: 15 }}
                      startIcon={<BarChartIcon />}
                    >
                      {collectionsTexts.buttonText}
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default DocumentsCollections;
